import React from 'react';
import { ShieldCheck } from 'lucide-react';

// Aviso de responsabilidade padrao para telas de dados publicos.
// Uso: <ResponsibilityNotice source="Tesouro Transparente" lastUpdated={iso} />
const ResponsibilityNotice = ({ source, lastUpdated, sourceUrl }) => (
  <div
    className="mt-6 p-4 rounded-lg border border-[#E2E8F0] bg-[#F9FAFB] text-xs text-[#475569]"
    data-testid="responsibility-notice"
  >
    <div className="flex items-start gap-2">
      <ShieldCheck className="w-4 h-4 shrink-0 mt-0.5 text-[#006030]" />
      <div>
        <p className="font-semibold text-[#0F1C2E]">Nossa responsabilidade com você.</p>
        <p className="mt-1 leading-relaxed">
          Todos os dados são oficiais e públicos. O Tô de Olho organiza e explica as informações para facilitar o entendimento do cidadão. Não emitimos opinião sobre parlamentares ou instituições.
        </p>
        {source && (
          <p className="mt-2 text-[11px]">
            <span className="font-semibold">Fonte:</span> {source}
            {sourceUrl && (
              <> · <a href={sourceUrl} target="_blank" rel="noopener noreferrer" className="text-[#006030] hover:underline">acesso à base</a></>
            )}
            {lastUpdated && <> · Atualizada em {new Date(lastUpdated).toLocaleDateString('pt-BR')}</>}
          </p>
        )}
      </div>
    </div>
  </div>
);

export default ResponsibilityNotice;
